<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container bottom-footer mt auth">
        <!-- Outer Row -->
        <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5 text-center">
                <div class="text-black">
                    <LogoColor formatting="logo-center" :width="text_auth != 'true'?'300px':'250px'" :class="text_auth != 'true'?'mt-5':''" ></LogoColor>
                    <div class="d-none d-md-block d-xl-block d-lg-block" v-if="text_auth == 'true'">
                        <h3>Olá cliente!</h3>
                        <p class="text-justify">✨ Bem-vindo(a) à sua área de cliente! ✨
                            A plataforma Soul foi desenvolvida com muito amor e dedicação, para que você sinta acolhimento, didática e a
                            certeza de que continuaremos oferecendo um atendimento humano e amoroso. Somos Gratas por ter
                            você com a gente.❤️💙
                        </p>
                    </div>

                </div>
            </div>

            <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 border-left">

                <div class="card o-hidden border-0 shadow-lg">
                    <div class="card-body card-body-no-spaccing">
                        <!-- Nested Row within Card Body -->
                        <div class="row ">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div class="p-5">

                                    <form class="user" @submit="checkAuthentication">
                                        <div class="form-group">
                                            <label for="">Informe seu CPF / CNPJ</label>
                                            <input type="text" class="form-control form-control-user" id="document"
                                                aria-describedby="documentHelp" placeholder="xxx.xxx.xxx-xx"
                                                v-mask="['###.###.###-##', '##.###.###/####-##']"
                                                v-model="authentication.document">
                                        </div>
                                        <div class="form-group">
                                            <label for="">Informe sua senha</label>
                                            <input type="password" class="form-control form-control-user"
                                                id="exampleInputPassword" placeholder="********"
                                                v-model="authentication.password">
                                        </div>

                                        <button type="submit" :disabled='!isDisabled'
                                            class="btn btn-primary btn-user btn-block">
                                            Acessar {{ name_arrea }} <i class="fas fa-sign-in-alt"></i>
                                        </button>
                                    </form>
                                    <hr>
                                    <router-link class="btn btn-link" to="resetPassword">Esqueci minha senha</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import LogoColor from '../img/logo-color.vue';
import axios from 'axios';


export default {
    directives: { mask },
    components: { LogoColor, Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            url_api: '',
            text_auth:'',
            name_arrea:'',
            authentication: {
                document: '',
                password: ''
            }
        }
    },
    computed: {
        isDisabled: function () {
            return this.authentication.document != '' && this.authentication.password != '';
        }
    },
    methods: {
        onCancel() { },
        async checkAuthentication(event) {
            event.preventDefault();
            this.isLoading = true;
            try {
                const response = await axios.post(this.url_api + "/auth-client", this.authentication);
                localStorage.setItem('token', response.data.session.token);
                localStorage.setItem('email', response.data.session.email);
                localStorage.setItem('name', response.data.session.name);
                localStorage.setItem('role', response.data.session.roles[0]);
                localStorage.setItem('expire_in', response.data.session.expire_in);
                localStorage.setItem('change_password', response.data.session.change_password);
                localStorage.setItem('client_id', response.data.client_id);
                localStorage.setItem('type', response.data.type);
                localStorage.setItem('term_use',response.data.term_use);
                localStorage.setItem('text_term_use',response.data.text_term_use.term);

                this.isLoading = false;
                this.$router.push('/');
            } catch (err) {
                this.isLoading = false;
                if (err.status == 401) {
                    this.$notify({
                        title: "Falha",
                        text: "Documento e/ou senha inválido(s)!",
                        type: 'error'
                    });
                } else if (err.status == 417) {
                    this.$notify({
                        title: "Falha",
                        text: "Este usuário não pode ter acesso a esta área!",
                        type: 'error'
                    });
                } else if (err.status == 423) {
                    this.$notify({
                        title: "Falha",
                        text: "Este usuário está com restrição de acesso!",
                        type: 'error'
                    });
                }else {
                    this.$notify({
                        title: "Falha",
                        text: "Sistema indisponível! Tente novamente mais tarde.",
                        type: 'error'
                    });
                }
            }
        }
    },

    beforeMount(){
        this.text_auth = process.env.VUE_APP_TEXT_AUTH
        this.name_arrea = process.env.VUE_APP_NAME_AREA_CLIENT
    },
    mounted() {

        this.isLoading = false;
        this.url_api = process.env.VUE_APP_URL_API
     

    }
}
</script>

<style>
* {
    scrollbar-width: none;
}

.auth{
    position: relative;
    top:120px;
    bottom:200px;
    padding-bottom: 200px;
}
.text-black {
    color: #000;
}

.bottom-footer {
    margin-top: 5%;
    margin-bottom: 400px;
}
@media screen and (max-width: 600px) {
    .auth{
        top:50px;
    }
}
</style>